import Axios from "axios"

export default {

  /**
   * 列表
   * @param {*} project_id
   * @param {*} keyword 
   * @param {*} contract_start_date 
   * @param {*} contract_end_date 
   * @param {*} page 
   */
  listPage(
    project_id,
    keyword,
    contract_start_date,
    contract_end_date,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/contract/page`, {
      params: {
        project_id,
        keyword,
        contract_start_date,
        contract_end_date,
        page
      }
    });
  },

  /**
   * 详情
   * @param {*} contractId 
   */
  info(
    contractId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/contract/${contractId}`);
  },

  /**
   * 小程序比对记录
   * @param {*} realname 
   * @param {*} start_date 
   * @param {*} end_date 
   * @param {*} page 
   */
  miniProgramListPage(
    realname,
    start_date,
    end_date,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/faceCompareLog/miniProgramFaceCompareLogList`, {
      params: {
        realname,
        start_date,
        end_date,
        page
      }
    });
  },

  /**
   * 一体机比对记录
   * @param {*} realname 
   * @param {*} start_date 
   * @param {*} end_date 
   * @param {*} page 
   */
  aioListPage(
    realname,
    start_date,
    end_date,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/faceCompareLog/aioDeviceFaceCompareLogList`, {
      params: {
        realname,
        start_date,
        end_date,
        page
      }
    });
  },

}